/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetIntegrationsConfig200ResponseTehtrisTriggersCriticalities } from './GetIntegrationsConfig200ResponseTehtrisTriggersCriticalities';
import {
    GetIntegrationsConfig200ResponseTehtrisTriggersCriticalitiesFromJSON,
    GetIntegrationsConfig200ResponseTehtrisTriggersCriticalitiesFromJSONTyped,
    GetIntegrationsConfig200ResponseTehtrisTriggersCriticalitiesToJSON,
    GetIntegrationsConfig200ResponseTehtrisTriggersCriticalitiesToJSONTyped,
} from './GetIntegrationsConfig200ResponseTehtrisTriggersCriticalities';

/**
 * 
 * @export
 * @interface GetIntegrationsConfig200ResponseTehtrisTriggers
 */
export interface GetIntegrationsConfig200ResponseTehtrisTriggers {
    /**
     * 
     */
    newFindings: boolean;
    /**
     * 
     */
    regressionFindings: boolean;
    /**
     * 
     */
    resolvedFindings: boolean;
    /**
     * 
     */
    criticalities: GetIntegrationsConfig200ResponseTehtrisTriggersCriticalities;
    /**
     * 
     */
    groupThreshold?: number;
}

/**
 * Check if a given object implements the GetIntegrationsConfig200ResponseTehtrisTriggers interface.
 */
export function instanceOfGetIntegrationsConfig200ResponseTehtrisTriggers(value: object): value is GetIntegrationsConfig200ResponseTehtrisTriggers {
    if (!('newFindings' in value) || value['newFindings'] === undefined) return false;
    if (!('regressionFindings' in value) || value['regressionFindings'] === undefined) return false;
    if (!('resolvedFindings' in value) || value['resolvedFindings'] === undefined) return false;
    if (!('criticalities' in value) || value['criticalities'] === undefined) return false;
    return true;
}

export function GetIntegrationsConfig200ResponseTehtrisTriggersFromJSON(json: any): GetIntegrationsConfig200ResponseTehtrisTriggers {
    return GetIntegrationsConfig200ResponseTehtrisTriggersFromJSONTyped(json, false);
}

export function GetIntegrationsConfig200ResponseTehtrisTriggersFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetIntegrationsConfig200ResponseTehtrisTriggers {
    if (json == null) {
        return json;
    }
    return {
        
        'newFindings': json['newFindings'],
        'regressionFindings': json['regressionFindings'],
        'resolvedFindings': json['resolvedFindings'],
        'criticalities': GetIntegrationsConfig200ResponseTehtrisTriggersCriticalitiesFromJSON(json['criticalities']),
        'groupThreshold': json['groupThreshold'] == null ? undefined : json['groupThreshold'],
    };
}

export function GetIntegrationsConfig200ResponseTehtrisTriggersToJSON(json: any): GetIntegrationsConfig200ResponseTehtrisTriggers {
    return GetIntegrationsConfig200ResponseTehtrisTriggersToJSONTyped(json, false);
}

export function GetIntegrationsConfig200ResponseTehtrisTriggersToJSONTyped(value?: GetIntegrationsConfig200ResponseTehtrisTriggers | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'newFindings': value['newFindings'],
        'regressionFindings': value['regressionFindings'],
        'resolvedFindings': value['resolvedFindings'],
        'criticalities': GetIntegrationsConfig200ResponseTehtrisTriggersCriticalitiesToJSON(value['criticalities']),
        'groupThreshold': value['groupThreshold'],
    };
}

